export default "__VITE_ASSET__CGjuBCpv__"